import React from 'react';
import { motion } from 'framer-motion';
import { Factory } from 'lucide-react';
import { TSR_CONTENT } from '../../utils/constants';
import { fadeInUp } from '../../utils/animations';

const TSRSection = () => {
  return (
    <section className="py-20 bg-neutral-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <motion.div
            className="inline-flex items-center justify-center w-14 h-14 bg-neutral-200 rounded-2xl mb-6"
            variants={fadeInUp}
          >
            <Factory size={28} className="text-neutral-700" />
          </motion.div>
          <motion.h2
            className="text-3xl sm:text-4xl text-neutral-900 leading-tight mb-6"
            style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}
            variants={fadeInUp}
          >
            {TSR_CONTENT.heading}
          </motion.h2>
          <motion.p
            className="text-neutral-600 text-lg leading-relaxed mb-8"
            style={{ fontFamily: "'Livvic', sans-serif" }}
            variants={fadeInUp}
          >
            {TSR_CONTENT.text}
          </motion.p>
          <motion.p
            className="text-neutral-400 text-sm font-medium uppercase tracking-wider"
            variants={fadeInUp}
          >
            {TSR_CONTENT.tagline}
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default TSRSection;